// extracted by mini-css-extract-plugin
export var calculatedBadge = "_wx-8";
export var container = "_wx-0";
export var radioDot = "_wx-5";
export var radioDotSelected = "_wx-6";
export var row = "_wx-1";
export var rowFirst = "_wx-2";
export var rowLast = "_wx-3";
export var rowSelected = "_wx-4";
export var strikethrough = "_wx-7";